export const toNumber = (val, fallback = 0) => {
    const n = parseFloat(val)
    return isNaN(n) ? fallback : n
}

export const getRandom = (min = 0, max = 1000000000) => {
    return Math.floor(Math.random() * (max - min + 1)) + min;
}

export const parseMinPrice = (value) => {
    if (typeof value === 'string') {
        const parts = value
            .split('-')
            .map(v => parseFloat(v.trim()))
            .filter(v => !isNaN(v));
        if (parts.length > 0) {
            return Math.min(...parts);
        }
    } else if (typeof value === 'number') {
        return value;
    }
    return null;
}

export const isValidDate = str => {
    if (!str) return false

    return !isNaN(new Date(str).getTime())
}

export const copyCommonFields = (obj1, obj2) => {
    Object.keys(obj2).forEach(key => {
        if (obj1.hasOwnProperty(key)) {
            obj2[key] = obj1[key]
        }
    })
}

export const getCopiedJSON = json => JSON.parse(JSON.stringify(json))

export const removeAllSpaces = str => {
    return String(str).replace(/\s+/g, '');
}

export const isNormalString = (str) => {
    if (typeof str !== 'string') return false
    return /[A-Za-z]/.test(str) || /\d/.test(str)
}

export const slugify = (text = "") => {
    return (text ?? "")
        .toLowerCase()
        .trim()
        .replace(/&/g, ' and ')
        .replace(/[\/\s_]+/g, '-')
        .replace(/[^a-z0-9-]+/g, '')
        .replace(/-+/g, '-')
        .replace(/^-|-$/g, '');
}

export const getAddressLine = ({ address1, address2, city, state, postal, country }) => {
    const cityLine = [city, [state, postal].filter(Boolean).join(' ')].filter(Boolean).join(', ');
    return [address1, address2, cityLine, country].filter(Boolean).join(', ');
}

const COUNTRY_PRIORITY = ['canada', 'usa', 'united states', 'united states of america'];

export const sortCountriesByPriority = (countries = []) => {
    const rank = (name) => {
        const i = COUNTRY_PRIORITY.indexOf(String(name ?? '').trim().toLowerCase());
        return i === -1 ? COUNTRY_PRIORITY.length : i;
    };
    return [...countries].sort((a, b) => {
        const ra = rank(a.country);
        const rb = rank(b.country);
        if (ra !== rb) return ra - rb;
        return String(a.country).localeCompare(String(b.country));
    });
}

